import { render } from "./addCustomField.vue?vue&type=template&id=00d3ee1c&scoped=true"
import script from "./addCustomField.vue?vue&type=script&lang=js"
export * from "./addCustomField.vue?vue&type=script&lang=js"

import "./addCustomField.vue?vue&type=style&index=0&id=00d3ee1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d3ee1c"]])

export default __exports__